import { createTheme } from "@mui/material";
import { SHADOWS } from "../enums/themeEnum";

export const light = createTheme(({
  palette: {
    mode: 'light',
    primary: {
      main: '#02AFF0'
    },
    grey: {
      main: '#f6f6f6',
      dark: '#919EAB',
      light: '#C4CDD5'
    },
    error: {
      main: '#F96D82',
      light: '#FEE8E2'
    },
    info: {
      main: '#0bbdff'
    },
    warning: {
      main: '#FFB83F',
      light: '#FFF6D8'
    },
    success: {
      main: '#78E236',
    },
    text: {
      main: '#212B36',
      semiLight: '#454F5B',
      light: '#637381',
    },
    background: {
      default: '#F6F6F6',
      lightBlue: '#E2F0FC'
    },
    borders: {
      main: '#ecf0f3'
    }
  },
  typography: {
    fontFamily: 'Inter',
    body1: {
      fontSize: '14px'
    },
    body2: {
      fontSize: '12px'
    }
  },
  breakpoints: {
    values: {
      xxs: 0,
      xs: 300,
      xsm: 635,
      mds: 1024,
      sm: 1366,
      md: 1440,
      lg: 1680,
      xl: 1920,
      xxl: 2160
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
          borderRadius: '100px',
          boxShadow: 'none',
          minWidth: 100,
          fontWeight: 600,
          '&:hover': {
            boxShadow: SHADOWS.light
          },
          '&.MuiButton-contained': {
            color: '#FFF',
          },
          '&.longButton': {
            width: '250px',
          },
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        fullWidth: true,
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          '.MuiOutlinedInput-root': {
            borderRadius: '10px',
            background: '#FFF',
            fontSize: '16px !important'
          },
          '& fieldset': {
            border: '1px solid #C4CDD5',
          },
          '& input::placeholder': {
            color: '#C4CDD5',
            opacity: 1,
          },
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          '.MuiDialog-paper': {
            borderRadius: '20px',
            padding: '32px 24px',
            boxShadow: 'none',
            border: 'none',
            backgroundColor: '#F9FAFB',
          },
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          padding: '24px',
          borderRadius: '16px',
          boxShadow: 'none'
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          '&.subTitle': {
            fontSize: '20px',
            color: '#02AFF0',
            fontWeight: 700
          },
        }
      }
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: '#f2f4f4'
        }
      }
    }
  }
}))  